module.exports = __webpack_public_path__ + "img/badge-list-thumb-157.d6126422.png";